import moment, { Moment } from 'moment'; // tslint:disable-line:import-blacklist
import * as React from 'react';
import { DateRangePicker, FocusedInputShape, OrientationShape } from 'react-dates';
import 'react-dates/initialize';

interface Props {
    startDate?: string | null;
    endDate?: string | null;
    onChange: (field: 'startDate' | 'endDate', value: string) => void;
    orientation: OrientationShape;
}

interface State {
    startDate: moment.Moment | null;
    endDate: moment.Moment | null;
    focusedInput: FocusedInputShape | null;
    daySize: number;
}

export default class DateRange extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            startDate: props.startDate ? moment(props.startDate) : props.endDate ? null : moment(),
            endDate: props.endDate ? moment(props.endDate) : null,
            focusedInput: props.endDate ? 'startDate' : 'endDate',
            daySize: 41,
        };
    }

    UNSAFE_componentWillMount() {
        this.onResize();
    }

    componentDidMount() {
        window.addEventListener('resize', this.onResize);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.onResize);
    }

    onFocusChange = (focusedInput: FocusedInputShape | null) => {
        this.setState({ focusedInput });
    };

    onDatesChange = (startDate: Moment | null, endDate: Moment | null) => {
        this.setState({ startDate, endDate });
        this.props.onChange('startDate', startDate ? startDate.format('YYYY-MM-DD') : '');
        this.props.onChange('endDate', endDate ? endDate.format('YYYY-MM-DD') : '');
    };

    onResize = () => {
        if (this.props.orientation == 'vertical') {
            this.setState({ daySize: Math.round((window.innerWidth * 0.63) / 7) });
        } else {
            this.setState({ daySize: 41 });
        }
    };

    render() {
        const { focusedInput, startDate, endDate, daySize } = this.state;

        return (
            <div>
                <DateRangePicker
                    startDate={startDate}
                    startDateId="start_date_id"
                    startDatePlaceholderText={__('Start date')}
                    endDate={endDate}
                    endDateId="end_date_id"
                    endDatePlaceholderText={__('End date')}
                    onDatesChange={({ startDate, endDate }) => {
                        this.onDatesChange(startDate, endDate);
                    }}
                    focusedInput={focusedInput}
                    onFocusChange={focusedInput => {
                        this.onFocusChange(focusedInput);
                    }}
                    showClearDates={true}
                    hideKeyboardShortcutsPanel={true}
                    keepOpenOnDateSelect={true}
                    reopenPickerOnClearDates={true}
                    orientation={this.props.orientation}
                    block={true}
                    daySize={daySize}
                />
            </div>
        );
    }
}
